import style from "./index.css";

const Loader = () => (
  <>
    <div className="loader-container">
      <div className="loadingio-spinner-rolling-q6gvtqfmm3j">
        <div className="ldio-d52igmd3au">
          <div></div>
        </div>
      </div>
    </div>
    <style jsx>{style}</style>
  </>
);

export default Loader;
